// import { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Database, Plus, Trash2, CheckCircle2, AlertCircle, RefreshCw, Link as LinkIcon, Sparkles, Layers, ArrowRight } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

// const API_BASE = 'https://api.lionsmd320.org/admin/api/api';
// const ALLOWED_TYPES = ['VARCHAR(255)', 'TEXT', 'INT', 'DECIMAL(10,2)', 'DATE', 'DATETIME', 'BOOLEAN', 'IMAGE'];

// export default function SchemaAdminModule({ onNavigateToResponses }) {
//     const navigate = useNavigate();
//     const [existingColumns, setExistingColumns] = useState([]);
//     const [selectedColumns, setSelectedColumns] = useState([]);
//     const [formTitle, setFormTitle] = useState('');
//     const [createdForms, setCreatedForms] = useState([]);
//     const [newColumns, setNewColumns] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [fetching, setFetching] = useState(false);
//     const [statusMsg, setStatusMsg] = useState({ type: '', text: '' });

//     const loadData = async () => {
//         setFetching(true);
//         try {
//             const res = await axios.get(`${API_BASE}/forms/schema`);
//             if (res.data.success) {
//                 const defaultIgnored = ['id', 'form_id', 'created_at'];
//                 const filterCols = res.data.columns.filter(c => !defaultIgnored.includes(c.Field));
//                 setExistingColumns(filterCols);
//                 setCreatedForms(res.data.forms);
//             }
//         } catch (err) {
//             showStatus('error', 'Failed to fetch database schema details.');
//         } finally {
//             setFetching(false);
//         }
//     };

//     useEffect(() => { loadData(); }, []);

//     const handleCheckboxToggle = (colName) => {
//         if (selectedColumns.includes(colName)) {
//             setSelectedColumns(selectedColumns.filter(c => c !== colName));
//         } else {
//             setSelectedColumns([...selectedColumns, colName]);
//         }
//     };

//     const handleDeleteDbColumn = async (colName) => {
//         const confirmDelete = window.confirm(
//             `Are you sure you want to permanently delete column '${colName}' from lionsmd_forms_? All data inside this column will be lost!`
//         );
//         if (!confirmDelete) return;

//         try {
//             const res = await axios.delete(`${API_BASE}/forms/column/${colName}`);
//             if (res.data.success) {
//                 showStatus('success', res.data.message);
//                 setSelectedColumns(selectedColumns.filter(c => c !== colName));
//                 loadData();
//             }
//         } catch (err) {
//             showStatus('error', err.response?.data?.error || `Failed to drop column '${colName}'`);
//         }
//     };

//     const handleAddNewColField = () => {
//         setNewColumns([...newColumns, { name: '', type: 'VARCHAR(255)', notNull: false }]);
//     };

//     const handleRemoveNewCol = (index) => {
//         setNewColumns(newColumns.filter((_, i) => i !== index));
//     };

//     const handleNewColChange = (index, field, value) => {
//         const updated = [...newColumns];
//         updated[index][field] = value;
//         setNewColumns(updated);
//     };

//     const handleCreateForm = async (e) => {
//         e.preventDefault();
//         if (!formTitle.trim()) return showStatus('error', 'Form Title is required.');

//         const dynamicNewCols = newColumns.filter(c => c.name.trim() !== '');
//         const combinedCols = [...selectedColumns, ...dynamicNewCols.map(c => c.name.trim())];

//         if (combinedCols.length === 0) {
//             return showStatus('error', 'Select at least one existing column or define a new column.');
//         }

//         setLoading(true);
//         try {
//             const res = await axios.post(`${API_BASE}/forms/create`, {
//                 formTitle,
//                 selectedColumns: combinedCols,
//                 newColumns: dynamicNewCols
//             });

//             if (res.data.success) {
//                 showStatus('success', 'Form route published successfully!');
//                 setFormTitle('');
//                 setNewColumns([]);
//                 setSelectedColumns([]);
//                 loadData();
//             }
//         } catch (err) {
//             showStatus('error', err.response?.data?.error || 'Failed to create form URL route.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const showStatus = (type, text) => {
//         setStatusMsg({ type, text });
//         setTimeout(() => setStatusMsg({ type: '', text: '' }), 4000);
//     };

//     return (
//         <div style={{ backgroundColor: '#f8fafc', color: '#0f172a', minHeight: '100vh', padding: '32px 20px', fontFamily: 'Inter, system-ui, -apple-system, sans-serif', letterSpacing: '-0.01em' }}>
//             <div style={{ maxWidth: '1280px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '28px' }}>

//                 {/* Header Section */}
//                 <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '20px' }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
//                         <div style={{ width: '42px', height: '42px', borderRadius: '12px', background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.1), rgba(2, 132, 199, 0.05))', border: '1px solid rgba(14, 165, 233, 0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0284c7' }}>
//                             <Database size={20} />
//                         </div>
//                         <div>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                                 <h1 style={{ fontSize: '22px', fontWeight: '700', margin: 0, color: '#0f172a', letterSpacing: '-0.02em' }}>Form Schema Architect</h1>
//                                 <span style={{ fontSize: '11px', fontWeight: '600', fontFamily: 'monospace', backgroundColor: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: '6px', border: '1px solid #bae6fd' }}>lionsmd_forms_</span>
//                             </div>
//                             <p style={{ fontSize: '13px', color: '#64748b', margin: '4px 0 0' }}>Manage structural database attributes, configure layouts, and launch unique collection endpoints.</p>
//                         </div>
//                     </div>

//                     <button onClick={loadData} disabled={fetching} style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', color: '#334155', padding: '9px 16px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', transition: 'all 0.2s ease' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f1f5f9'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}>
//                         <RefreshCw size={14} style={{ animation: fetching ? 'spin 1s linear infinite' : 'none' }} />
//                         Refresh Schema
//                     </button>
//                 </header>

//                 {/* Status Toast Banner */}
//                 {statusMsg.text && (
//                     <div style={{ padding: '14px 18px', borderRadius: '12px', backgroundColor: statusMsg.type === 'error' ? '#fef2f2' : '#f0fdf4', border: `1px solid ${statusMsg.type === 'error' ? '#fecaca' : '#bbf7d0'}`, color: statusMsg.type === 'error' ? '#991b1b' : '#166534', display: 'flex', alignItems: 'center', gap: '12px', fontSize: '13px', fontWeight: '500', boxShadow: '0 2px 6px rgba(0,0,0,0.02)' }}>
//                         {statusMsg.type === 'error' ? <AlertCircle size={18} /> : <CheckCircle2 size={18} />}
//                         <span>{statusMsg.text}</span>
//                     </div>
//                 )}

//                 {/* Main Content Dashboard Grid */}
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))', gap: '24px' }}>

//                     {/* Builder Box */}
//                     <div style={{ backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.03)' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                             <Sparkles size={16} color="#0284c7" />
//                             <h2 style={{ fontSize: '15px', fontWeight: '600', color: '#0f172a', margin: 0, letterSpacing: '-0.01em' }}>
//                                 Create Dynamic Form Route
//                             </h2>
//                         </div>

//                         <form onSubmit={handleCreateForm} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
//                             {/* Form Title Input */}
//                             <div>
//                                 <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569', display: 'block', marginBottom: '8px' }}>
//                                     Form Title <span style={{ color: '#0284c7' }}>*</span>
//                                 </label>
//                                 <input type="text" placeholder="e.g. Member Registration Form" value={formTitle} onChange={(e) => setFormTitle(e.target.value)} style={{ width: '100%', backgroundColor: '#f8fafc', border: '1px solid #cbd5e1', color: '#0f172a', padding: '12px 14px', borderRadius: '10px', fontSize: '13px', boxSizing: 'border-box', outline: 'none', transition: 'border-color 0.2s, box-shadow 0.2s' }}
//                                     onFocus={(e) => { e.target.style.borderColor = '#0284c7'; e.target.style.boxShadow = '0 0 0 3px rgba(2, 132, 199, 0.1)'; }}
//                                     onBlur={(e) => { e.target.style.borderColor = '#cbd5e1'; e.target.style.boxShadow = 'none'; }}
//                                     required
//                                 />
//                             </div>

//                             {/* Existing Columns Checkbox Selector */}
//                             <div>
//                                 <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569', display: 'block', marginBottom: '8px' }}>
//                                     Select Existing Columns from Database:
//                                 </label>
//                                 <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '10px', maxHeight: '240px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px' }}>
//                                     {existingColumns.length === 0 ? (
//                                         <p style={{ fontSize: '12px', color: '#94a3b8', margin: '12px', textAlign: 'center' }}>
//                                             No extra columns found. Add new ones below!
//                                         </p>
//                                     ) : (
//                                         existingColumns.map((col) => {
//                                             const isSelected = selectedColumns.includes(col.Field);
//                                             return (
//                                                 <div key={col.Field} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', borderRadius: '8px', backgroundColor: isSelected ? '#e0f2fe' : 'transparent', border: `1px solid ${isSelected ? '#bae6fd' : 'transparent'}`, transition: 'all 0.15s ease' }}>
//                                                     <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px', cursor: 'pointer', color: '#334155', flex: 1, margin: 0 }}>
//                                                         <input type="checkbox" checked={isSelected} onChange={() => handleCheckboxToggle(col.Field)} style={{ accentColor: '#0284c7', width: '15px', height: '15px', cursor: 'pointer' }} />
//                                                         <span style={{ fontFamily: 'monospace', color: isSelected ? '#0369a1' : '#1e293b', fontWeight: '600' }}>{col.Field}</span>
//                                                         <span style={{ fontSize: '11px', color: '#64748b' }}>({col.Type})</span>
//                                                     </label>

//                                                     <button type="button" onClick={() => handleDeleteDbColumn(col.Field)} style={{ backgroundColor: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', padding: '6px', display: 'flex', alignItems: 'center', borderRadius: '6px', opacity: 0.7, transition: 'opacity 0.2s' }}
//                                                         onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
//                                                         onMouseLeave={(e) => e.currentTarget.style.opacity = '0.7'}
//                                                         title={`Delete column '${col.Field}' from database`}
//                                                     >
//                                                         <Trash2 size={14} />
//                                                     </button>
//                                                 </div>
//                                             );
//                                         })
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Add New Columns Configurator */}
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                                 <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569' }}>
//                                     Inject New Dynamic Columns:
//                                 </label>
//                                 {newColumns.map((col, index) => (
//                                     <div key={index} style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
//                                         <input type="text" placeholder="Column Name" value={col.name} onChange={(e) => handleNewColChange(index, 'name', e.target.value)} style={{ flex: 1, backgroundColor: '#f8fafc', border: '1px solid #cbd5e1', color: '#0f172a', padding: '9px 12px', borderRadius: '8px', fontSize: '12px', outline: 'none' }} />
//                                         <select value={col.type} onChange={(e) => handleNewColChange(index, 'type', e.target.value)} style={{ backgroundColor: '#f8fafc', border: '1px solid #cbd5e1', color: '#0369a1', padding: '9px 10px', borderRadius: '8px', fontSize: '12px', outline: 'none', cursor: 'pointer' }}>
//                                             {ALLOWED_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
//                                         </select>
//                                         <button type="button" onClick={() => handleRemoveNewCol(index)} style={{ backgroundColor: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', padding: '4px' }}>
//                                             <Trash2 size={15} />
//                                         </button>
//                                     </div>
//                                 ))}

//                                 <button type="button" onClick={handleAddNewColField} style={{ backgroundColor: '#f0f9ff', border: '1px dashed #7dd3fc', color: '#0284c7', padding: '10px', borderRadius: '10px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', transition: 'background 0.2s' }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e0f2fe'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f0f9ff'}
//                                 >
//                                     <Plus size={14} /> Add Column Definition
//                                 </button>
//                             </div>

//                             {/* Submit Button */}
//                             <button type="submit" disabled={loading} style={{ backgroundColor: '#0284c7', color: '#ffffff', border: 'none', padding: '13px', borderRadius: '10px', fontWeight: '600', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)', transition: 'all 0.2s ease', marginTop: '4px' }}
//                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0369a1'}
//                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0284c7'}
//                             >
//                                 <Database size={16} />
//                                 {loading ? 'Publishing Endpoint...' : 'Publish Form URL Route'}
//                             </button>
//                         </form>
//                     </div>

//                     {/* Published Form Routes List */}
//                     <div style={{ backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.03)' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                 <Layers size={16} color="#0284c7" />
//                                 <h2 style={{ fontSize: '15px', fontWeight: '600', color: '#0f172a', margin: 0, letterSpacing: '-0.01em' }}>
//                                     Published Form Routes
//                                 </h2>
//                             </div>
//                             <span style={{ fontSize: '12px', color: '#64748b', backgroundColor: '#f1f5f9', padding: '2px 8px', borderRadius: '6px', fontWeight: '500' }}>
//                                 {createdForms.length} active
//                             </span>
//                         </div>

//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxHeight: '520px', overflowY: 'auto', paddingRight: '4px' }}>
//                             {createdForms.length === 0 ? (
//                                 <div style={{ textAlign: 'center', padding: '40px 20px', color: '#94a3b8' }}>
//                                     <Database size={32} style={{ opacity: 0.3, marginBottom: '10px' }} />
//                                     <p style={{ fontSize: '13px', margin: 0 }}>No form routes published yet.</p>
//                                 </div>
//                             ) : (
//                                 createdForms.map((form) => (
//                                     <div key={form.form_id} style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '10px', transition: 'border-color 0.2s, box-shadow 0.2s' }}
//                                         onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)'; }}
//                                         onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = 'none'; }}
//                                     >
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                             <strong style={{ fontSize: '14px', color: '#0f172a', fontWeight: '600' }}>{form.title}</strong>
//                                             <button
//                                                 onClick={() => {
//                                                     if (typeof onNavigateToResponses === 'function') {
//                                                         onNavigateToResponses(form.form_id);
//                                                     } else {
//                                                         navigate(`/admin/responses/${form.form_id}`);
//                                                     }
//                                                 }}
//                                                 style={{ backgroundColor: '#e0f2fe', border: '1px solid #bae6fd', color: '#0369a1', padding: '5px 10px', borderRadius: '6px', fontSize: '11px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', transition: 'background 0.2s' }}
//                                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#bae6fd'}
//                                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#e0f2fe'}
//                                             >
//                                                 View CRUD Data <ArrowRight size={12} />
//                                             </button>
//                                         </div>

//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#ffffff', padding: '8px 10px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
//                                             <LinkIcon size={12} color="#0284c7" />
//                                             <a href={form.form_url} target="_blank" rel="noreferrer" style={{ fontSize: '12px', color: '#0284c7', wordBreak: 'break-all', textDecoration: 'none' }}>
//                                                 {form.form_url}
//                                             </a>
//                                         </div>

//                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2px' }}>
//                                             <span style={{ fontSize: '11px', color: '#64748b' }}>
//                                                 ID: <code style={{ color: '#475569' }}>{form.form_id}</code>
//                                             </span>
//                                             <span style={{ fontSize: '11px', color: '#64748b' }}>
//                                                 Created: {new Date(form.created_at).toLocaleDateString()}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 ))
//                             )}
//                         </div>
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// }









import { useState, useEffect } from 'react';
import axios from 'axios';
import { Database, Plus, Trash2, CheckCircle2, AlertCircle, RefreshCw, Link as LinkIcon, Sparkles, Layers, ArrowRight, Lock, LogOut, Edit2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const API_BASE = 'https://api.lionsmd320.org/admin/api/api';
const API_BASEAuth = 'https://api.lionsmd320.org/admin/api';
const ALLOWED_TYPES = ['VARCHAR(255)', 'TEXT', 'INT', 'DECIMAL(10,2)', 'DATE', 'DATETIME', 'BOOLEAN', 'IMAGE'];

export default function SchemaAdminModule({ onNavigateToResponses }) {
    const navigate = useNavigate();

    // Auth States
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('schema_admin_auth') === 'true';
    });
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState('');
    const [loginLoading, setLoginLoading] = useState(false);

    // Dashboard States
    const [existingColumns, setExistingColumns] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [formTitle, setFormTitle] = useState('');
    const [createdForms, setCreatedForms] = useState([]);
    const [newColumns, setNewColumns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [statusMsg, setStatusMsg] = useState({ type: '', text: '' });

    // Edit Form State
    const [editingFormId, setEditingFormId] = useState(null);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoginError('');
        setLoginLoading(true);

        try {
            const res = await axios.post(`${API_BASEAuth}/lionsmd-forms-login`, {
                username,
                password
            });

            if (res.data.success) {
                setIsAuthenticated(true);
                localStorage.setItem('schema_admin_auth', 'true');
                localStorage.setItem('schema_admin_user', JSON.stringify(res.data.user));
            }
        } catch (err) {
            const errorMsg = err.response?.data?.error || 'Invalid email or password. Please try again.';
            setLoginError(errorMsg);
        } finally {
            setLoginLoading(false);
        }
    };

    const handleLogout = () => {
        setIsAuthenticated(false);
        localStorage.removeItem('schema_admin_auth');
        localStorage.removeItem('schema_admin_user');
        setUsername('');
        setPassword('');
    };

    const loadData = async () => {
        setFetching(true);
        try {
            const storedUser = JSON.parse(localStorage.getItem('schema_admin_user') || '{}');
            const userId = storedUser.id;

            const res = await axios.get(`${API_BASE}/forms/schema`, {
                params: { userId }
            });

            if (res.data.success) {
                const defaultIgnored = ['id', 'user_id', 'form_id', 'created_at'];
                const filterCols = res.data.columns.filter(c => !defaultIgnored.includes(c.Field));
                setExistingColumns(filterCols);
                setCreatedForms(res.data.forms);
            }
        } catch (err) {
            showStatus('error', 'Failed to fetch database schema details.');
        } finally {
            setFetching(false);
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            loadData();
        }
    }, [isAuthenticated]);

    const handleCheckboxToggle = (colName) => {
        if (selectedColumns.includes(colName)) {
            setSelectedColumns(selectedColumns.filter(c => c !== colName));
        } else {
            setSelectedColumns([...selectedColumns, colName]);
        }
    };

    const handleDeleteDbColumn = async (colName) => {
        const confirmDelete = window.confirm(
            `Are you sure you want to permanently delete column '${colName}'? All data inside this column will be lost!`
        );
        if (!confirmDelete) return;

        try {
            const res = await axios.delete(`${API_BASE}/forms/column/${colName}`);
            if (res.data.success) {
                showStatus('success', res.data.message);
                setSelectedColumns(selectedColumns.filter(c => c !== colName));
                loadData();
            }
        } catch (err) {
            showStatus('error', err.response?.data?.error || `Failed to drop column '${colName}'`);
        }
    };


    // Delete Form Handler
    const handleDeleteForm = async (formId, force = false) => {
        if (!force && !window.confirm("Are you sure you want to delete this form?")) {
            return;
        }

        try {
            const response = await fetch(`https://api.lionsmd320.org/admin/api/api/forms/${formId}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ forceDelete: force })
            });

            const data = await response.json();

            if (!data.success && data.requiresConfirmation) {
                // Backend caught that submissions exist — ask user for confirmation
                const confirmWithData = window.confirm(data.message);
                if (confirmWithData) {
                    // Re-trigger deletion with forceDelete = true
                    await handleDeleteForm(formId, true);
                }
            } else if (data.success) {
                alert(data.message);
                // Refresh your forms list state using loadData instead of fetchFormsList
                loadData();
            } else {
                alert('Error: ' + data.message);
            }
        } catch (err) {
            console.error("Failed to delete form:", err);
            alert("An error occurred while deleting the form.");
        }
    };
    // Start Editing Form Handler
    const handleStartEditForm = (form) => {
        setEditingFormId(form.form_id);
        setFormTitle(form.title || '');
        let formCols = [];
        try {
            if (form.columns) {
                formCols = Array.isArray(form.columns)
                    ? form.columns
                    : (typeof form.columns === 'string' ? JSON.parse(form.columns || '[]') : []);
            } else if (form.selected_columns) {
                formCols = Array.isArray(form.selected_columns)
                    ? form.selected_columns
                    : JSON.parse(form.selected_columns || '[]');
            }
        } catch (e) {
            console.error("Failed to parse form columns JSON:", e);
            formCols = [];
        }
        setSelectedColumns(formCols);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleCancelEdit = () => {
        setEditingFormId(null);
        setFormTitle('');
        setNewColumns([]);
        setSelectedColumns([]);
    };

    const handleAddNewColField = () => {
        setNewColumns([...newColumns, { name: '', type: 'VARCHAR(255)', notNull: false }]);
    };

    const handleRemoveNewCol = (index) => {
        setNewColumns(newColumns.filter((_, i) => i !== index));
    };

    const handleNewColChange = (index, field, value) => {
        const updated = [...newColumns];
        updated[index][field] = value;
        setNewColumns(updated);
    };

    const handleCreateForm = async (e) => {
        e.preventDefault();
        if (!formTitle.trim()) return showStatus('error', 'Form Title is required.');
        const dynamicNewCols = newColumns.filter(c => c.name.trim() !== '');
        const combinedCols = [...selectedColumns, ...dynamicNewCols.map(c => c.name.trim())];
        if (combinedCols.length === 0 && !editingFormId) {
            return showStatus('error', 'Select at least one existing column or define a new column.');
        }
        const storedUser = JSON.parse(localStorage.getItem('schema_admin_user') || '{}');
        const userId = storedUser.id || null;
        setLoading(true);
        try {
            let res;
            if (editingFormId) {
                res = await axios.put(`${API_BASE}/forms/${editingFormId}`, {
                    formTitle,
                    selectedColumns: combinedCols,
                    newColumns: dynamicNewCols,
                    userId
                });
            } else {
                res = await axios.post(`${API_BASE}/forms/create`, {
                    formTitle,
                    selectedColumns: combinedCols,
                    newColumns: dynamicNewCols,
                    userId
                });
            }
            if (res.data.success) {
                showStatus('success', editingFormId ? 'Form updated successfully!' : 'Form route published successfully!');
                setFormTitle('');
                setNewColumns([]);
                setSelectedColumns([]);
                setEditingFormId(null);
                loadData();
            }
        } catch (err) {
            showStatus('error', err.response?.data?.error || 'Failed to save form route.');
        } finally {
            setLoading(false);
        }
    };

    const showStatus = (type, text) => {
        setStatusMsg({ type, text });
        setTimeout(() => setStatusMsg({ type: '', text: '' }), 4000);
    };

    if (!isAuthenticated) {
        return (
            <div style={{ backgroundColor: '#f8fafc', color: '#0f172a', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                <div style={{ width: '100%', maxWidth: '400px', backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '32px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)', display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                        <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.1), rgba(2, 132, 199, 0.05))', border: '1px solid rgba(14, 165, 233, 0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0284c7' }}>
                            <Lock size={22} />
                        </div>
                        <div>
                            <h1 style={{ fontSize: '18px', fontWeight: '700', margin: 0, color: '#0f172a' }}>Schema Admin Login</h1>
                            <p style={{ fontSize: '13px', color: '#64748b', margin: '4px 0 0' }}>Enter your database credentials to access.</p>
                        </div>
                    </div>

                    {loginError && (
                        <div style={{ padding: '10px 14px', borderRadius: '8px', backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', fontSize: '12px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <AlertCircle size={16} />
                            <span>{loginError}</span>
                        </div>
                    )}

                    <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div>
                            <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569', display: 'block', marginBottom: '6px' }}>Email ID</label>
                            <input type="email" placeholder="e.g. admin320@gmail.com" value={username} onChange={(e) => setUsername(e.target.value)} style={{ width: '100%', backgroundColor: '#f8fafc', border: '1px solid #cbd5e1', color: '#0f172a', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', boxSizing: 'border-box', outline: 'none' }} required />
                        </div>
                        <div>
                            <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569', display: 'block', marginBottom: '6px' }}>Password</label>
                            <input type="password" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: '100%', backgroundColor: '#f8fafc', border: '1px solid #cbd5e1', color: '#0f172a', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', boxSizing: 'border-box', outline: 'none' }} required />
                        </div>
                        <button type="submit" disabled={loginLoading} style={{ backgroundColor: '#0284c7', color: '#ffffff', border: 'none', padding: '11px', borderRadius: '8px', fontWeight: '600', fontSize: '13px', cursor: 'pointer', marginTop: '6px', opacity: loginLoading ? 0.7 : 1 }}>
                            {loginLoading ? 'Authenticating...' : 'Login to Dashboard'}
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div style={{ backgroundColor: '#f8fafc', color: '#0f172a', minHeight: '100vh', padding: '32px 20px', fontFamily: 'Inter, system-ui, sans-serif' }}>
            <div style={{ maxWidth: '1280px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '28px' }}>
                <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                        <div style={{ width: '42px', height: '42px', borderRadius: '12px', background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.1), rgba(2, 132, 199, 0.05))', border: '1px solid rgba(14, 165, 233, 0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0284c7' }}>
                            <Database size={20} />
                        </div>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <h1 style={{ fontSize: '22px', fontWeight: '700', margin: 0, color: '#0f172a' }}>Create Forms</h1>
                                <span style={{ fontSize: '11px', fontWeight: '600', fontFamily: 'monospace', backgroundColor: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: '6px', border: '1px solid #bae6fd' }}>lionsmd_forms_</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <button onClick={loadData} disabled={fetching} style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', color: '#334155', padding: '9px 16px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500' }}>
                            <RefreshCw size={14} style={{ animation: fetching ? 'spin 1s linear infinite' : 'none' }} />Refresh Schema
                        </button>
                        <button onClick={handleLogout} style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', padding: '9px 16px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500' }}>
                            <LogOut size={14} />Logout
                        </button>
                    </div>
                </header>

                {statusMsg.text && (
                    <div style={{ padding: '14px 18px', borderRadius: '12px', backgroundColor: statusMsg.type === 'error' ? '#fef2f2' : '#f0fdf4', border: `1px solid ${statusMsg.type === 'error' ? '#fecaca' : '#bbf7d0'}`, color: statusMsg.type === 'error' ? '#991b1b' : '#166534', display: 'flex', alignItems: 'center', gap: '12px', fontSize: '13px', fontWeight: '500' }}>
                        {statusMsg.type === 'error' ? <AlertCircle size={18} /> : <CheckCircle2 size={18} />}
                        <span>{statusMsg.text}</span>
                    </div>
                )}

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))', gap: '24px' }}>

                    {/* Create/Edit Form Column */}
                    <div style={{ backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.03)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Sparkles size={16} color="#0284c7" />
                                <h2 style={{ fontSize: '15px', fontWeight: '600', color: '#0f172a', margin: 0 }}>
                                    {editingFormId ? 'Edit Dynamic Form Route' : 'Create Dynamic Form Route'}
                                </h2>
                            </div>
                            {editingFormId && (
                                <button type="button" onClick={handleCancelEdit} style={{ background: 'none', border: 'none', color: '#64748b', fontSize: '12px', cursor: 'pointer', textDecoration: 'underline' }}>
                                    Cancel Edit
                                </button>
                            )}
                        </div>

                        <form onSubmit={handleCreateForm} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569', display: 'block', marginBottom: '8px' }}>Form Title <span style={{ color: '#0284c7' }}>*</span></label>
                                <input type="text" placeholder="e.g. Member Registration Form" value={formTitle} onChange={(e) => setFormTitle(e.target.value)} style={{ width: '100%', backgroundColor: '#f8fafc', border: '1px solid #cbd5e1', color: '#0f172a', padding: '12px 14px', borderRadius: '10px', fontSize: '13px', boxSizing: 'border-box', outline: 'none' }} required />
                            </div>
                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569', display: 'block', marginBottom: '8px' }}>Select Existing Columns from Database:</label>
                                <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '10px', maxHeight: '240px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    {existingColumns.length === 0 ? (
                                        <p style={{ fontSize: '12px', color: '#94a3b8', margin: '12px', textAlign: 'center' }}>No extra columns found. Add new ones below!</p>
                                    ) : (
                                        existingColumns.map((col) => {
                                            const isSelected = selectedColumns.includes(col.Field);
                                            return (
                                                <div key={col.Field} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', borderRadius: '8px', backgroundColor: isSelected ? '#e0f2fe' : 'transparent', border: `1px solid ${isSelected ? '#bae6fd' : 'transparent'}` }}>
                                                    <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px', cursor: 'pointer', color: '#334155', flex: 1, margin: 0 }}>
                                                        <input type="checkbox" checked={isSelected} onChange={() => handleCheckboxToggle(col.Field)} style={{ accentColor: '#0284c7', width: '15px', height: '15px', cursor: 'pointer' }} />
                                                        <span style={{ fontFamily: 'monospace', color: isSelected ? '#0369a1' : '#1e293b', fontWeight: '600' }}>{col.Field}</span>
                                                        <span style={{ fontSize: '11px', color: '#64748b' }}>({col.Type})</span>
                                                    </label>
                                                    <button type="button" onClick={() => handleDeleteDbColumn(col.Field)} style={{ backgroundColor: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', padding: '6px', display: 'flex', alignItems: 'center', borderRadius: '6px' }} title={`Delete column '${col.Field}' from database`}><Trash2 size={14} /></button>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {newColumns.map((col, index) => (
                                    <div key={index} style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <input type="text" placeholder="Column Name" value={col.name} onChange={(e) => handleNewColChange(index, 'name', e.target.value)} style={{ flex: 1, backgroundColor: '#f8fafc', border: '1px solid #cbd5e1', color: '#0f172a', padding: '9px 12px', borderRadius: '8px', fontSize: '12px', outline: 'none' }} />
                                        <select value={col.type} onChange={(e) => handleNewColChange(index, 'type', e.target.value)} style={{ backgroundColor: '#f8fafc', border: '1px solid #cbd5e1', color: '#0369a1', padding: '9px 10px', borderRadius: '8px', fontSize: '12px', outline: 'none', cursor: 'pointer' }}>
                                            {ALLOWED_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                                        </select>
                                        <button type="button" onClick={() => handleRemoveNewCol(index)} style={{ backgroundColor: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', padding: '4px' }}>
                                            <Trash2 size={15} />
                                        </button>
                                    </div>
                                ))}

                                <button type="button" onClick={handleAddNewColField} style={{ backgroundColor: '#f0f9ff', border: '1px dashed #7dd3fc', color: '#0284c7', padding: '10px', borderRadius: '10px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}><Plus size={14} /> Add Column</button>
                            </div>

                            <button type="submit" disabled={loading} style={{ backgroundColor: '#0284c7', color: '#ffffff', border: 'none', padding: '13px', borderRadius: '10px', fontWeight: '600', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)', marginTop: '4px' }}>
                                <Database size={16} />{loading ? 'Saving Endpoint...' : (editingFormId ? 'Update Form Route' : 'Publish Form URL Route')}
                            </button>
                        </form>
                    </div>

                    {/* Published Form Routes List */}
                    <div style={{ backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.03)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Layers size={16} color="#0284c7" />
                                <h2 style={{ fontSize: '15px', fontWeight: '600', color: '#0f172a', margin: 0 }}>Published Forms</h2>
                            </div>
                            <span style={{ fontSize: '12px', color: '#64748b', backgroundColor: '#f1f5f9', padding: '2px 8px', borderRadius: '6px', fontWeight: '500' }}>
                                {createdForms.length} active
                            </span>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxHeight: '520px', overflowY: 'auto', paddingRight: '4px' }}>
                            {createdForms.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: '40px 20px', color: '#94a3b8' }}>
                                    <Database size={32} style={{ opacity: 0.3, marginBottom: '10px' }} />
                                    <p style={{ fontSize: '13px', margin: 0 }}>No form routes published yet.</p>
                                </div>
                            ) : (
                                createdForms.map((form) => (
                                    <div key={form.form_id} style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <strong style={{ fontSize: '14px', color: '#0f172a', fontWeight: '600' }}>{form.title}</strong>

                                            {/* Action Buttons: View Data, Edit Icon, Delete Icon */}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <button onClick={() => { if (typeof onNavigateToResponses === 'function') { onNavigateToResponses(form.form_id); } else { navigate(`/admin/responses/${form.form_id}`); } }}
                                                    style={{ backgroundColor: '#e0f2fe', border: '1px solid #bae6fd', color: '#0369a1', padding: '5px 10px', borderRadius: '6px', fontSize: '11px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    View Data <ArrowRight size={12} />
                                                </button>

                                                {/* Edit Form Button */}
                                                <button
                                                    onClick={() => handleStartEditForm(form)}
                                                    style={{ backgroundColor: '#f1f5f9', border: '1px solid #cbd5e1', color: '#334155', padding: '5px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                                    title="Edit Form">
                                                    <Edit2 size={13} />
                                                </button>

                                                {/* Delete Form Button */}
                                                <button
                                                    onClick={() => handleDeleteForm(form.form_id)}
                                                    style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '5px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                                    title="Delete Form">
                                                    <Trash2 size={13} />
                                                </button>
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#ffffff', padding: '8px 10px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                            <LinkIcon size={12} color="#0284c7" />
                                            <a href={form.form_url} target="_blank" rel="noreferrer" style={{ fontSize: '12px', color: '#0284c7', wordBreak: 'break-all', textDecoration: 'none' }}>
                                                {form.form_url}
                                            </a>
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2px' }}>
                                            <span style={{ fontSize: '11px', color: '#64748b' }}>
                                                ID: <code style={{ color: '#475569' }}>{form.form_id}</code>
                                            </span>
                                            <span style={{ fontSize: '11px', color: '#64748b' }}>
                                                Created: {new Date(form.created_at).toLocaleDateString()}
                                            </span>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}